<template>
  <div>
    <h2 class="text-center">{{ $store.getters['trade/getVehicleName'] }}</h2>
    <p class="lead-text text-center mb-5">{{ $t('message.trade.infoForm.leadText') }}</p>
    <div class="row my-4">
      <div class="col-sm d-none d-sm-flex">
        <div class="flex-fill">
          <svg
            class="mr-3 icon"
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 56 56"
            xmlns:v="https://vecta.io/nano"
          >
            <path
              d="M28 0C12.536 0 0 12.536 0 28s12.536 28 28 28 28-12.536 28-28S43.464 0 28 0zm0 5.419c12.479 0 22.581 10.099 22.581 22.581S40.481 50.581 28 50.581 5.419 40.481 5.419 28 15.519 5.419 28 5.419h0zm15.829 14.708l-2.544-2.565c-.527-.531-1.385-.535-1.916-.008L23.41 33.385l-6.751-6.805c-.527-.531-1.385-.535-1.916-.008l-2.565 2.544c-.531.527-.535 1.385-.008 1.916L22.42 41.365c.527.531 1.385.535 1.916.008l19.486-19.329c.531-.527.534-1.385.008-1.916h0z"
              fill="#007bc7"
              fill-rule="evenodd"
            />
          </svg>
          <div class="d-inline-block">
            <p class="card-text float-right mr-4">{{ $t('message.trade.infoForm.firstCardText') }}</p>
          </div>
        </div>
      </div>
      <div class="vertical"></div>
      <div class="col-sm d-none d-sm-flex">
        <div class="flex-fill">
          <svg
            class="mr-3 icon"
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 56 56"
            xmlns:v="https://vecta.io/nano"
          >
            <path
              d="M54.462 24.712L31.288 1.538A5.25 5.25 0 0 0 27.575 0H5.25A5.25 5.25 0 0 0 0 5.25v22.325a5.25 5.25 0 0 0 1.538 3.712l23.175 23.175a5.25 5.25 0 0 0 7.425 0l22.325-22.325a5.25 5.25 0 0 0 0-7.425zM28.425 50.75L5.25 27.575V5.25h22.325L50.75 28.425 28.425 50.75zM21 15.75a5.25 5.25 0 0 1-10.5 0 5.25 5.25 0 0 1 10.5 0z"
              fill="#007bc7"
              fill-rule="evenodd"
            />
          </svg>
          <div class="d-inline-block">
            <p class="card-text mr-4">{{ $t('message.trade.infoForm.secondCardText') }}</p>
          </div>
        </div>
      </div>
      <div class="vertical"></div>
      <div class="col-sm d-none d-sm-flex">
        <div class="flex-fill">
          <svg
            class="mr-3 icon"
            xmlns="http://www.w3.org/2000/svg"
            width="34"
            height="30"
            viewBox="0 0 63 56"
            xmlns:v="https://vecta.io/nano"
          >
            <path
              d="M56 17.5H45.5V7a7.01 7.01 0 0 0-7-7H7a7.01 7.01 0 0 0-7 7v17.5a7.01 7.01 0 0 0 7 7h3.5v5.688c0 .777.634 1.313 1.313 1.313.263 0 .536-.077.777-.263L21 33.48V42a7.01 7.01 0 0 0 7 7h10.5l11.911 6.737c.241.175.514.263.777.263.678 0 1.313-.536 1.313-1.312V49H56a7.01 7.01 0 0 0 7-7V24.5a7.01 7.01 0 0 0-7-7zm-45.5 8.75H7c-.963 0-1.75-.788-1.75-1.75V7c0-.962.787-1.75 1.75-1.75h31.5c.963 0 1.75.788 1.75 1.75v17.5c0 .962-.787 1.75-1.75 1.75H23.122l-1.203.678-6.169 3.489V26.25H10.5zM57.75 42c0 .963-.787 1.75-1.75 1.75h-8.75v4.167l-6.169-3.489-1.203-.678H28c-.963 0-1.75-.787-1.75-1.75V31.5H38.5a7.01 7.01 0 0 0 7-7v-1.75H56c.963 0 1.75.788 1.75 1.75V42h0z"
              fill="#007bc7"
              fill-rule="evenodd"
            />
          </svg>
          <div class="d-inline-block">
            <p class="card-text mr-4">{{ $t('message.trade.infoForm.thirdCardText') }}</p>
          </div>
        </div>
      </div>
    </div>
    <PersonalInfoForm
      :buttonLabelKey="buttonLabelKey"
      @FormIsValid="continueForm"
      sample-report
      :av-errors="avErrors"
    ></PersonalInfoForm>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';
import { avErrorMixin } from '@/mixins';
import log from '@/services/log';
import PersonalInfoForm from '../../../components/trade-in/PersonalInfoForm.vue';

export default {
  data() {
    return {};
  },
  mixins: [avErrorMixin],
  props: ['year', 'make', 'model', 'trim', 'style'],
  components: { PersonalInfoForm },
  computed: {
    ...mapGetters('business', ['getPhoneNumberVerificationArray', 'tradeAcquireAdditionalVehicleDetails']),
    ...mapGetters(['getCurrentProduct']),
    buttonLabelKey() {
      if (this.tradeAcquireAdditionalVehicleDetails) {
        return 'common.continue';
      }
      return this.getPhoneNumberVerificationArray.trade ? 'common.continue' : 'trade.buttonLabel.seeTradeValue';
    },
  },
  methods: {
    ...mapMutations(['trade/SET_VEHICLE', 'SET_LOADING']),
    async continueForm(isValid) {
      if (!isValid) {
        return;
      }
      try {
        this.$store.commit('SET_LOADING', true);
        await this.$store.dispatch('lead/createLead');
        try {
          this.$store.commit('trade/SET_LEAD_TRADEIN_VEHICLE');
          await this.$store.dispatch('trade/getReport');
          if (this.tradeAcquireAdditionalVehicleDetails) {
            this.$router.push({ name: `additional-vehicle-details-${this.baseRoute}` });
            return;
          }
          if (this.getPhoneNumberVerificationArray.trade) {
            this.$router.push({ name: `tradein-mobile-verification-${this.baseRoute}` });
          } else {
            this.$router.push({ name: `report-${this.baseRoute}` });
          }
        } catch (err) {
          log('Error on getting trade-in report! [desktop]', err);
          this.$router.push({ name: `report-${this.baseRoute}` });
        } finally {
          try {
            await this.$store.dispatch('lead/updateLead');
          } catch (err) {
            log('Error in Trade personal form - Update Lead [desktop]', err);
            this.$router.push({ name: `trade-in-error-${this.baseRoute}` });
          } finally {
            this.$store.commit('SET_LOADING', false);
          }
        }
      } catch (err) {
        if (!this.handleServerSideError(err)) {
          log('Error in Trade Personal Info Form - Create lead [desktop]', err);
          this.$router.push({ name: `trade-in-error-${this.baseRoute}` });
        }
      } finally {
        this.$store.commit('SET_LOADING', false);
      }
    },
  },
  created() {
    // Set a vehicle object from the props
    // This will be needed when a user comes from the tradein widget
    this['trade/SET_VEHICLE']({
      year: decodeURIComponent(this.year),
      make: decodeURIComponent(this.make),
      model: decodeURIComponent(this.model),
      trim: decodeURIComponent(this.trim),
      style: decodeURIComponent(this.style || ''),
    });
  },
};
</script>
<style scoped lang="scss">
@import 'src/assets/scss/variables';
h2 {
  font-size: 28px;
  font-weight: bold;
}

.lead-text {
  font-size: 20px;
  font-weight: normal;
  color: #19222b;
}

.sample-report {
  max-width: 100%;
  height: auto;
}
.vertical {
  border-left: 1px solid #dae2ea;
  height: 94px;
  margin-right: 30px;
  margin-left: 20px;
  margin-bottom: 15px;
}
p.card-text {
  font-size: 14px;
  font-weight: normal;
  color: #19222b;
  position: absolute;
  margin-top: -20px;
}

svg.icon path {
  fill: $primary;
}
</style>
